.navbar-bg {
  width: 100%;

  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1360px;
  padding: 20px;
  margin-inline: auto;
}

@media (width < 500px) {
  .navbar {
    padding: 10px;
  }
}

.navbar h1 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5em;

  font-weight: bold;
  font-size: 1.75rem;
}

@media (width < 500px) {
  .navbar h1 {
    font-size: 1.35rem;
    gap: 0;
  }
}

.navbar img {
  width: 40px;
}

@media (width < 500px) {
  .navbar img {
    width: 30px;
  }
}

.navbar div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1.5rem;
}

@media (width < 500px) {
  .navbar div {
    gap: 0;
  }
}

.navbar a {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;

  text-decoration: none;
  color: black;
}

.navbar a:hover {
  border-radius: 10px;
  background-color: black;
  color: white;
}
